import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Button, Menu, MenuItem } from '@mui/material';
import { useState, useMemo } from 'react';
import {
  useOptimisticSubmitAdd,
  useOptimisticSubmitRemove,
} from '../../../../context/invoices/InvoiceLiveStatusContext';
import { bulkSubmitInvoices, getInvoices } from '../../../../redux/slices/invoicing';
import { useDispatch } from '../../../../redux/store';
import DropdownAction from '../../../../reusable-components/dropdown-action/DropdownAction';

export default function SubmitSelectedInvoices({ setShowSelection, showSelection, activeRows }) {
  const dispatch = useDispatch();
  const optimisticAddSubmitting = useOptimisticSubmitAdd();
  const optimisticRemoveSubmitting = useOptimisticSubmitRemove();

  const [anchorEl, setAnchorEl] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submittingAll, setSubmittingAll] = useState(false);

  const invoicesInQueue = JSON.parse(localStorage.getItem('selectedInvoices')) || [];

  const submit = async (invoicesIds) => {
    optimisticAddSubmitting(invoicesIds);
      const response = await dispatch(bulkSubmitInvoices(invoicesIds));
    if (!response?.success) {
      optimisticRemoveSubmitting(invoicesIds);
    }
    await dispatch(getInvoices(false));
    setIsSubmitting(false);
  };
  const submitInvoices = async () => {
    setAnchorEl(null);
    setIsSubmitting(true);
    setShowSelection('');
    await submit(invoicesInQueue);
    localStorage.removeItem('selectedInvoices');
  };
  const submitAllInvoices = async () => {
    setSubmittingAll(true);
    setIsSubmitting(true);
    setShowSelection('');
    const queuedInvoices = submittableRows?.map((x) => x.id);
    await submit(queuedInvoices);
    setShowSelection('');
    setAnchorEl(null);
  };
  const cancel = () => {
    localStorage.removeItem('selectedInvoices');
    setShowSelection('');
  };
  const closeMenuDel = (e) => {
    setShowSelection('Submit invoices');
    setAnchorEl(null);
  };
  const submittableRows = useMemo(
    () => activeRows?.filter((x) => !x.submittingLocked && x.queInfo === null) || [],
    [activeRows]
  );

  return (
    <>
      {submittableRows?.length > 0 && (
        <>
          {showSelection !== 'Submit invoices' ? (
            <>
              <Button
                size="small"
                onClick={(e) => setAnchorEl(e.currentTarget)}
                variant="contained"
                color="secondary"
                endIcon={<ArrowDropDownIcon />}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </Button>

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl) && !isSubmitting}
                onClose={() => setAnchorEl(null)}
                disabled={isSubmitting}
                slotProps={{
                  paper: {
                    sx: {
                      width: 216,
                      p: 1,
                      borderRadius: '5px',
                      boxShadow: '0px 2px 6px rgba(0,0,0,.06), 0px 8px 24px rgba(0,0,0,.12)',
                    },
                  },
                  list: {
                    sx: {
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '14px',
                      p: 0,
                    },
                  },
                }}
              >
                <MenuItem onClick={closeMenuDel} sx={{ p: 0, minHeight: 'unset' }}>
                  <DropdownAction badgeIcon="mdi:checkbox-marked-outline">Select invoices</DropdownAction>
                </MenuItem>

                <MenuItem onClick={submitAllInvoices} sx={{ p: 0, minHeight: 'unset' }}>
                  <DropdownAction badgeIcon="mdi:arrow-right-circle-outline">Submit all invoices</DropdownAction>
                </MenuItem>
              </Menu>
            </>
          ) : (
            <>
              <Button
                variant="contained"
                size="small"
                sx={{ mr: 1, pr: 5, pl: 5 }}
                color="secondary"
                disabled={
                  (submittingAll && activeRows?.length === 0) ||
                  (!submittingAll && invoicesInQueue?.length === 0) ||
                  isSubmitting
                }
                onClick={() => {
                  submitInvoices();
                }}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </Button>

              <Button
                size="small"
                disabled={isSubmitting}
                x={{ mr: 1, textDecoration: 'underline' }}
                color="secondary"
                onClick={cancel}
              >
                Cancel
              </Button>
            </>
          )}
        </>
      )}
    </>
  );
}
